import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import { ContentProvider, useContent } from './context/ContentContext';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import { ModalProvider } from './context/ModalContext';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ProductsSection from './components/ProductsSection';
import ContactSection from './components/ContactSection';
import NewsSection from './components/NewsSection';
import NewsPage from './components/NewsPage';
import Footer from './components/Footer';
import Modal from './components/Modal';
import { getMenuConfig } from './lib/menuConfig';
import AdminApp from './admin/AdminApp';

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const scrollToHash = () => {
      const element = document.querySelector(location.hash);
      if (!element) return false;

      const targetTop = element.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
      return true;
    };

    if (scrollToHash()) return;

    const frameId = window.requestAnimationFrame(scrollToHash);
    const timeoutId = window.setTimeout(scrollToHash, 150);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.clearTimeout(timeoutId);
    };
  }, [location.pathname, location.hash]);

  return null;
}

function Providers({ children }) {
  return (
    <ContentProvider>
      <ThemeProvider>
        <LanguageProvider>
          <ModalProvider>
            {children}
          </ModalProvider>
        </LanguageProvider>
      </ThemeProvider>
    </ContentProvider>
  );
}

function MainWebsite() {
  const { siteContent } = useContent();
  const menuConfig = getMenuConfig(siteContent?.global?.menu);

  return (
    <div className="App min-h-screen bg-background text-foreground transition-colors duration-300">
      <ScrollToHash />
      <Header />
      <main>
        {menuConfig.home?.enabled !== false && <HeroSection />}
        {menuConfig.about?.enabled !== false && <AboutSection />}
        {menuConfig.products?.enabled !== false && <ProductsSection />}
        {menuConfig.contact?.enabled !== false && <ContactSection />}
      </main>
      <Footer />
      <Modal />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/news" element={<Providers><NewsPage /></Providers>} />
        <Route path="/*" element={<Providers><MainWebsite /></Providers>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
